import type { SxProps, Theme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';

type Props = {
	sx?: SxProps<Theme>;
	fill?: string;
};

export const PartiallyAcceptedIcon = ({ sx, fill }: Props) => {
	return (
		<SvgIcon width='20' height='20' viewBox='0 0 20 20' fill='none' sx={sx}>
			<path
				d='M8.39656 11.2684L6.66782 9.49736L5.60156 10.5573L8.39656 13.3523L14.3966 7.3523L13.2714 6.29492L8.39656 11.2684Z'
				fill={fill ?? '#1565C0'}
			/>
			<circle
				cx='9.979'
				cy='9.97998'
				r='7.504'
				stroke={fill ?? '#1565C0'}
				strokeWidth='1.7'
				strokeDasharray='6.3 2'
			/>
		</SvgIcon>
	);
};
